import { render, staticRenderFns } from "./OngoingCallComponent.vue?vue&type=template&id=dbaac7f6&"
import script from "./OngoingCallComponent.vue?vue&type=script&lang=ts&"
export * from "./OngoingCallComponent.vue?vue&type=script&lang=ts&"
import style0 from "./OngoingCallComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports